<template>
  <div class="feed-profile-sidebar">
    <div class="profile" v-if="user">
      <div
        class="profile__header"
        :style="{
          backgroundImage: user.profile?.cover_photo ? `url(${user.profile?.cover_photo})` : `url(${user?.cover_photo})`,
        }"
      ></div>
      <div class="profile__body">
        <button class="profile__body--btn" @click="copyProfileLink()">
          <svg
            width="16"
            height="14"
            viewBox="0 0 16 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.83265 12.5351C5.90547 13.1393 4.90221 13.3275 3.82287 13.0999C2.74353 12.8722 1.90177 12.2948 1.29758 11.3676C0.693392 10.4404 0.505125 9.43718 0.732779 8.35784C0.960432 7.2785 1.53785 6.43673 2.46503 5.83255L4.47579 4.52226C4.6657 4.39851 4.86674 4.35901 5.07892 4.40377C5.2911 4.44852 5.45906 4.56585 5.58281 4.75575C5.70656 4.94566 5.74606 5.1467 5.7013 5.35888C5.65655 5.57105 5.53922 5.73902 5.34932 5.86277L3.33856 7.17305C2.78001 7.53702 2.43264 8.04189 2.29644 8.68764C2.16023 9.3334 2.27412 9.93555 2.63809 10.4941C3.00205 11.0526 3.50692 11.4 4.15268 11.5362C4.79843 11.6724 5.40059 11.5585 5.95913 11.1946L7.96989 9.88428C8.15979 9.76054 8.36084 9.72104 8.57301 9.76579C8.78519 9.81054 8.95315 9.92787 9.0769 10.1178C9.20065 10.3077 9.24015 10.5087 9.1954 10.7209C9.15065 10.9331 9.03332 11.101 8.84341 11.2248L6.83265 12.5351ZM6.42611 8.98054C6.23621 9.10429 6.03517 9.14379 5.82299 9.09904C5.61081 9.05428 5.44285 8.93696 5.3191 8.74705C5.19535 8.55714 5.15585 8.3561 5.2006 8.14393C5.24535 7.93175 5.36268 7.76378 5.55259 7.64004L9.57411 5.01946C9.76401 4.89571 9.96505 4.85621 10.1772 4.90097C10.3894 4.94572 10.5574 5.06305 10.6811 5.25295C10.8049 5.44286 10.8444 5.6439 10.7996 5.85608C10.7549 6.06826 10.6375 6.23622 10.4476 6.35997L6.42611 8.98054ZM11.5244 9.47774C11.3345 9.60149 11.1335 9.64099 10.9213 9.59624C10.7091 9.55149 10.5412 9.43416 10.4174 9.24425C10.2937 9.05435 10.2542 8.85331 10.2989 8.64113C10.3437 8.42895 10.461 8.26099 10.6509 8.13724L12.6617 6.82695C13.2202 6.46298 13.5676 5.95812 13.7038 5.31236C13.84 4.6666 13.7261 4.06445 13.3621 3.50591C12.9982 2.94736 12.4933 2.59999 11.8475 2.46379C11.2018 2.32758 10.5996 2.44146 10.0411 2.80543L8.03033 4.11572C7.84042 4.23947 7.63938 4.27897 7.4272 4.23421C7.21503 4.18946 7.04706 4.07213 6.92331 3.88223C6.79956 3.69232 6.76007 3.49128 6.80482 3.2791C6.84957 3.06693 6.9669 2.89896 7.1568 2.77521L9.16756 1.46493C10.0947 0.86074 11.098 0.672473 12.1773 0.900126C13.2567 1.12778 14.0985 1.7052 14.7026 2.63238C15.3068 3.55957 15.4951 4.56283 15.2674 5.64217C15.0398 6.72151 14.4624 7.56327 13.5352 8.16746L11.5244 9.47774Z"
              fill="#1C1B1F"
            />
          </svg>
          Profile Link
          <div class="copied" v-if="copiedLink">
            <p>Copied!</p>
          </div>
        </button>
        <img
          :src="user.profile?.profile_picture"
          alt="Profile Image"
          class="profile__body--image"
        />
        <h2 class="profile__body--name">
          {{ user.profile?.full_name }}
        </h2>
        <p v-html="user.profile?.mission" class="profile__body--description" />
      </div>
    </div>
    <div class="feed-profile-sidebar__suggested-container">
      <div v-if="isLoggedInUser" class="feed-profile-sidebar__suggested-container--header">
        <h1>Contributors in your Network Feed</h1>
        <button @click="openAddContributorsModal()" class="btn">Add Contributors</button>
      </div>
      <div class="suggested">
        <div class="suggested__header">
          <div class="suggested__header--title">
            <h3>Contacts</h3>
            <button class="btn" @click="seeAllContacts()">See All</button>
          </div>
        </div>
        <div class="suggested__body" v-if="loadingFollowers">
          <skeleton-loader
            v-for="index in 3"
            :key="index"
          ></skeleton-loader>
        </div>
        <div class="suggested__body" v-else-if="contributors.length > 0">
          <div
            class="suggested-item"
            v-for="suggested in contributors.slice(0,4)"
            :key="suggested"
            @click="redirectToUser(suggested)"
          >
            <div class="suggested-item__image">
              <img
                :src="suggested.profile_picture"
                alt="Logo"
                class="suggested-item__image--img"
              />
            </div>
            <div class="suggested-item__details">
              <h1 class="suggested-item__details--name">
                {{ suggested.full_name }}
              </h1>
              <p class="suggested-item__details--description">
                {{ suggested?.job_title }}
              </p>
            </div>
          </div>
        </div>
        <p v-else class="suggested__message">No Contributors</p>
      </div>
      <div class="suggested">
        <div class="suggested__header">
          <div class="suggested__header--title">
            <h3>Organizations</h3>
            <button class="btn" @click="toggleSeeAllOrganizations()">See All</button>
          </div>
        </div>
        <div class="suggested__body" v-if="loadingFollowedOrgs">
          <skeleton-loader
            v-for="index in 3"
            :key="index"
          ></skeleton-loader>
        </div>
        <div class="suggested__body" v-else-if="followedOrgs.length > 0">
          <div class="suggested-item" v-for="org in followedOrgs.slice(0,4)" :key="org">
            <div class="suggested-item__image">
              <img
                :src="org.profile_picture"
                alt="Logo"
                class="suggested-item__image--img"
              />
            </div>
            <div class="suggested-item__details">
              <h2 class="suggested-item__details--name">{{ org.full_name }}</h2>
              <!-- <p class="suggested-item__details--description">
                {{ org.message }}
              </p> -->
            </div>
          </div>
        </div>
        <p v-else class="suggested__message">No Organization</p>
      </div>
      <div class="activity-container">
        <div class="activity-container__header">
          <div class="activity-container__header--title">
            <h3>Activity</h3>
            <!-- <button class="btn">See All</button> -->
          </div>
        </div>
        <div class="activity-container__body">
          <div class="activity-container__body--list">
            <div
              v-for="(item, index) in activityItems"
              :key="index"
              class="activity-container__body--list--item"
              :class="{ 'activity-container__body--list--active': activeKey?.key === index }"
              @click="setSelectedActivity(item.replaceAll(' ', '').toLowerCase(), index)"
            >
              <p>{{ item }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <add-contributors-modal
    :visible="visibleAddContributorsModal"
    :contributors="users"
    :isSeeAllContacts="isSeeAllContacts"
    :isOrgs="isSeeAllOrgs"
    @closeFeedUploadModal="closeAddContributorsModal"
  />
  <view-feed-modal
    :visible="visibleViewFeedActivityModal"
    @closeViewFeedModal="closeViewFeedActivityModal"
    :viewFeed="viewFeedActivity"
    :feedObject="viewFeedActivity"
  />
</template>

<script>
import AddContributorsModal from "./AddContributorsModal.vue";
import skeletonLoader from "../BaseComponents/ConnectionCardSkeleton.vue";
import ViewFeedModal from "./ViewFeedModal.vue";
import { mapGetters, mapActions } from "vuex";
// import TheReactionBadgeCounter from "../BaseComponents/TheReactionBadgeCounter.vue";
export default {
  props:{
    skeletonLoader:{
      type:Boolean,
      default: ()=>(false)
    }
  },
  data() {
    return {
      copiedLink: false,
      visibleAddContributorsModal: false,
      visibleViewFeedActivityModal: false,
      viewFeedActivity: {},
      isSeeAllContacts: false,
      isSeeAllOrgs: false,
      items: ['Feed', 'Activity', 'Comments'],
      activeItem: 0, // Default active item index
      
    };
  },
  components: {
    AddContributorsModal,
    skeletonLoader,
    ViewFeedModal,
    // TheReactionBadgeCounter
  },
  computed: {
    ...mapGetters({
      postActivities: 'feed/postActivities',
      commentActivites : 'feed/commentActivites',
      authUserInformation: 'profile/userInformation',
      loadingFollowers: 'feed/loadingFollowers',
      loadingFollowedOrgs: 'feed/loadingFollowedOrgs',
      activityLoader: 'feed/activityLoader',
      userInformation: 'profile/userInformation',
      activeKey: 'feed/activeKey'

    }),
    user() {
      return this.userInformation
    },
    followedOrgs() {
      return this.$store.getters["feed/getFollowedOrgs"];
    },
    contributors() {
      return this.$store.getters["feed/getContributors"];
    },
    users(){
      return this.isSeeAllOrgs ? this.followedOrgs : this.contributors
    },
    userId() {
      return this.$store.getters["auth/getUserId"];
    },
    activities(){
      return this.postActivities
    },
    isLoggedInUser() {
      return this.$store.getters["profile/isLoggedinUser"];
    },
    activityItems(){
      return this.$route.query?.id ? ['Feed'] : ['Feed', 'My Activity', 'Comments']
    }
  },
  watch:{
  },
  methods: {
    ...mapActions({
      setSelectedUser:'profile/setSelectedUser',
      fetchActivity: 'feed/fetchActivity',
      setActiveTabKey: 'profile/setActiveTabKey',
      toggleActivityLoader: 'feed/toggleActivityLoader',
      setActiveKey: 'feed/setActiveKey'
    }),
    copyProfileLink() {
      this.copiedLink = true;
      setTimeout(() => {
        this.copiedLink = false;
      }, 1000);
      const profileUrl = `${process.env.VUE_APP_REDIRECTION_URL}/share/${this.user.username}/`;
      navigator.clipboard.writeText(profileUrl);
    },
    openAddContributorsModal() {
      this.visibleAddContributorsModal = true;
    },
    closeAddContributorsModal() {
      this.visibleAddContributorsModal = false;
      this.isSeeAllOrgs = false;
      this.isSeeAllContacts = false
    },
    openViewFeedActivityModal(feed) {
      this.viewFeedActivity = feed
      this.visibleViewFeedActivityModal = true
    },
    closeViewFeedActivityModal() {
      this.visibleViewFeedActivityModal = false
    },
    async redirectToUser(user) {
      this.setActiveTabKey('experience')
      this.setSelectedUser(user)
      this.$store.dispatch("profile/fetchUserProfile", user.username);
      this.$router.push({
        path: `/user/${user.username}/`
      });
      // this.getUserInformation();
    },
    async getUserInformation() {
      try {
        await this.$store.dispatch("profile/fetchUserProfile");
        await this.$store.dispatch("profile/loadExperiences");
        await this.$store.dispatch("profile/getAddedLanguages");
        await this.$store.dispatch("profile/fetchPhotoResume");
      } catch (err) {
        console.log(err);
      }
    },
    seeAllContacts() {
      this.visibleAddContributorsModal = true;
      this.isSeeAllContacts = true;
    },
    toggleSeeAllOrganizations(){
      this.isSeeAllOrgs = true
      this.seeAllContacts()
    },
    setSelectedActivity(name, key){
      this.setActiveKey({name, key})
      if (this.$route.query?.id && name === 'feed') {
        this.$router.push({ name:'network-feed'})
      }
    }
  },
};
</script>

<style lang="scss">
.feed-profile-sidebar {
  border: 1px solid $color-dark-grey-5;
  border-radius: 2rem;
  background-color: $color-white;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  position: sticky;
  padding-bottom: 2rem;
  top: 0;
  .profile {
    margin-top: -1px;
    position: relative;
    &__header {
      height: 9.3rem;
      background-position: center;
      background-size: cover;
      background-repeat: no-repeat;
      border-start-end-radius: 2rem;
      border-start-start-radius: 2rem;
      position: absolute;
      width: 100%;
      background-color: #e7e7e9;
    }
    &__body {
      padding: 1.7rem 2.8rem;
      position: relative;
      z-index: 1;
      border-bottom: 1px solid $color-dark-grey-5;
      @include respond(tab-port) {
        padding: 1.7rem 2rem;
      }
      &--btn {
        border: none;
        outline: none;
        width: fit-content;
        height: fit-content;
        padding: 0.8rem 1rem;
        background-color: #ffffff9e;
        font-size: 1.2rem;
        color: #1c1b1f;
        font-family: $font-primary;
        display: flex;
        align-items: center;
        gap: 0.7rem;
        border-radius: 100px !important;
        position: absolute;
        right: 3.1rem;
        top: 1.7rem;
        cursor: pointer;
        line-height: normal;
        svg {
          width: 1.6rem;
          height: auto;
          margin-top: -0.2rem;
        }
        .copied {
          position: absolute;
          box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
          bottom: -3rem;
          padding: 0.5rem 1rem;
          border-radius: 0.5rem;
          z-index: 1;
          background-color: #ffffff9e;
          right: 1.7rem;
          p {
            font-size: 1.2rem;
            font-family: $font-primary;
            margin-bottom: 0;
            line-height: 1.6rem;
          }
        }
      }
      &--image {
        border: 3px solid $color-white;
        border-radius: 100%;
        height: 10rem;
        width: 10rem;
        margin-bottom: 1.6rem;
        object-fit: fill;
        display: inline-block;
      }
      &--name {
        font-size: 2rem;
        font-family: $font-primary-bold;
        color: $color-black;
        line-height: 2.3rem;
        margin-bottom: 0.8rem;
      }
      &--description {
        font-size: 1.4rem;
        font-family: $font-primary;
        color: $color-black;
        opacity: 0.7;
        line-height: 2rem;
        margin-bottom: 1rem;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2; /* number of lines to show */
                line-clamp: 2; 
        -webkit-box-orient: vertical;
        margin-bottom: 0;
        min-height: 3.6rem;
        p {
          margin-bottom: 0;
        }
      }
    }
  }
  &__suggested-container {
    max-height: calc(100vh - 37rem);
    min-height: calc(100vh - 37rem);
    height: max-content;
    overflow-y: auto;
    .btn {
      border: none;
      outline: none;
      background-color: transparent;
      width: fit-content;
      height: fit-content;
      line-height: normal;
      font-size: 1.4rem;
      font-family: $font-primary;
      color: $color-primary;
      cursor: pointer;
    }
    &--header {
      padding: 1.7rem 2.8rem;
      background-color: $color-white;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      gap: 1.5rem;
      @include respond(tab-port) {
        padding: 1.7rem 2rem;
      }
      z-index: 1;
      h1 {
        font-size: 1.8rem;
        font-family: $font-primary-bold;
        margin-bottom: 0;
        line-height: 2.3rem;
        color: $color-black;
        width: fit-content;
        max-width: 55%;
      }
      .btn {
        margin-top: 0.4rem;
      }
    }
    .suggested {
      padding: 2.6rem 2.8rem;
      border-top: 1px solid $color-dark-grey-5;
      @include respond(tab-port) {
        padding: 2.6rem 2rem;
      }
      &__header {
        margin-bottom: 2.4rem;
        &--title {
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          margin-bottom: 1.1rem;
          h3 {
            font-size: 1.8rem;
            font-family: $font-primary-medium;
            margin-bottom: 0;
            line-height: 2.1rem;
            color: $color-black;
          }
        }
      }
      &__body {
        display: flex;
        flex-direction: column;
        gap: 2.4rem;
        .suggested-item {
          display: flex;
          align-items: center;
          gap: 1.6rem;
          &__image {
            width: 4.8rem;
            height: 4.8rem;
            border-radius: 100%;
            cursor: pointer;
            &--img {
              width: 100%;
              height: 100%;
              border-radius: 100%;
              object-fit: fill;
              background-color: #ebebeb;
            }
          }
          &__activity-image {
            border-radius: 0.5rem;
            width: 4rem;
            height: 4rem;
            &--img {
              border-radius: 0.5rem;
              background-color: transparent;
            }
          }
          &__details {
            width: calc(100% - 4.8rem);
            &--name {
              font-size: 1.6rem;
              font-family: $font-primary-medium;
              color: $color-black;
              line-height: 1.8rem;
              cursor: pointer;
              margin-bottom: 0;
              overflow: hidden;
              display: -webkit-box;
              -webkit-line-clamp: 1;
                      line-clamp: 1; 
              -webkit-box-orient: vertical;
            }
            &--description {
              font-size: 1.2rem;
              font-family: $font-primary;
              color: $color-black;
              line-height: 1.5rem;
              margin-bottom: 0;
              opacity: 0.7;
              margin-top: 0.5rem;
            }
          }
          &__activity-details {
            &--name {
              font-family: $font-primary;
              &:hover {
                text-decoration: underline;
              }
            }
          }
        }
        .connection-card-skeleton {
         margin: 0 !important;
         .ant-skeleton-header {
          .ant-skeleton-avatar {
            border-radius: 100%;
          }
         } 
        }
      }
      &__message {
        font-size: 1.6rem;
        font-family: $font-primary;
        color: $color-black;
        line-height: 1.8rem;
        margin-bottom: 1rem;
        text-align: center;
      }
    }
    .activity-container {
      height: 100%;
      position: relative;
      border-top: 1px solid $color-dark-grey-5;
      &__header {
        margin-bottom: 2.4rem;
        padding: 2.6rem 2.8rem 0;
        @include respond(tab-port) {
          padding: 2.6rem 2rem 0;
        }
        &--title {
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          h3 {
            font-size: 1.8rem;
            font-family: $font-primary-medium;
            margin-bottom: 0;
            line-height: 2.1rem;
            color: $color-black;
          }
        }
      }
      &__body {
        &--list {
          margin: 0 2.8rem;
          width: calc(100% - 5.6rem);
          @include respond(tab-port) {
            margin: 0rem 2rem;
            width: calc(100% - 4rem);
          }
          &--item {
            height: 4rem;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 2rem;
            background-color: $color-white;
            border-radius: 0.8rem;
            cursor: pointer;
            transition: background-color 0.3s, color 0.3s;
            margin: 0.5rem 0;
            p {
              font-size: 1.6rem;
              font-family: $font-primary;
              margin-bottom: 0;
              line-height: normal;
              color: $color-black;
            }
            img {
              width: 2.2rem;
              height: auto;
              transform: rotate(180deg);
              margin-right: -1rem;
            }
            &:hover {
              background-color: #80808024;
            }
          }
          &--active {
            background-color: #80808024;
            p {
              font-family: $font-primary-medium;
            }
          }
        }
        .ant-tabs {
          .ant-tabs-bar {
            margin: 0;
            margin-bottom: 0.5rem;
            border: none;

            .ant-tabs-nav-container {
              padding: 0 2.7rem;

              .ant-tabs-tab-prev,
              .ant-tabs-tab-next {
                display: none !important;
              }

              .ant-tabs-nav-wrap {
                .ant-tabs-nav-scroll {
                  overflow-x: auto;

                  @include respond(phone-x-small) {
                    &::-webkit-scrollbar {
                      display: none !important;
                    }
                  }
                  &::-webkit-scrollbar {
                    height: 0.5rem;
                    width: 0.5rem;
                  }

                  &::-webkit-scrollbar-track {
                    background-color: transparent;
                    border-radius: 0.8rem;
                    height: 0.5rem;
                    width: 0.5rem;
                  }

                  &::-webkit-scrollbar-thumb {
                    background-color: $color-primary;
                    border-radius: 0.8rem;
                  }

                  .ant-tabs-nav {
                    width: 100%;
                    transform: none !important;
                    .ant-tabs-tab {
                      padding: 0.9rem 2rem;
                      border-radius: 100px;
                      border: 1px solid $color-dark-grey-5;
                      margin-right: 1.2rem;
                      margin-bottom: 0.2rem;
                      .tab-name {
                        display: flex;
                        align-items: center;
                        p {
                          font-size: 1.4rem;
                          line-height: normal;
                          font-family: $font-primary;
                          color: $color-dark-grey-6;
                          margin: 0;
                        }
                      }

                      &:last-child {
                        margin-right: 0;
                      }
                    }

                    .ant-tabs-tab-active {
                      background-color: $color-primary;
                      text-shadow: none;
                      border-color: $color-primary;
                      .tab-name {
                        p {
                          color: $color-white;
                          font-family: $font-primary-medium;
                        }
                      }
                    }

                    .ant-tabs-ink-bar {
                      display: none !important;
                    }
                  }
                  .ant-tabs-nav > div {
                    display: flex;
                  }
                }
              }
            }
          }

          .ant-tabs-top-content {
            .ant-tabs-tabpane {
              height: max-content;
              overflow: hidden;
              padding: 0 2.7rem;
              .list {
                &__item {
                  border-bottom: 1px solid $color-dark-grey-5;
                  padding: 2rem 0 1.5rem;
                  &--header {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin-bottom: 1.2rem;
                    opacity: 0.7;
                    h1 {
                      font-size: 1.2rem;
                      font-family: $font-primary;
                      color: $color-black;
                      margin-bottom: 0;
                      line-height: 1.4rem;
                      overflow: hidden;
                      display: -webkit-box;
                      -webkit-line-clamp: 1;
                              line-clamp: 1; 
                      -webkit-box-orient: vertical;
                    }
                    span {
                      font-family: $font-primary-medium;
                    }
                  }
                  &--body {
                    display: flex;
                    align-items: center;
                    .image {
                      width: 5rem;
                      height: 5rem;
                      border-radius: 0.8rem;
                      margin-right: 1rem;
                      cursor: pointer;
                      img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        border-radius: 0.8rem;
                        background-color: #ebebeb;
                      }
                    }
                    .details {
                      display: flex;
                      flex-direction: column;
                      gap: 0.8rem;
                      width: calc(100% - 6rem);
                      .message {
                        font-size: 1.4rem;
                        font-family: $font-primary;
                        color: $color-black;
                        line-height: 1.8rem;
                        margin-bottom: 0;
                        overflow: hidden;
                        display: -webkit-box;
                        -webkit-line-clamp: 1;
                                line-clamp: 1; 
                        -webkit-box-orient: vertical;
                      }
                      .title {
                        font-size: 1.6rem;
                        font-family: $font-primary;
                        color: $color-black;
                        line-height: 2rem;
                        margin-bottom: 0;
                        overflow: hidden;
                        cursor: pointer;
                        display: -webkit-box;
                        -webkit-line-clamp: 1;
                                line-clamp: 1; 
                        -webkit-box-orient: vertical;
                        width: 100%;
                        * {
                          margin: 0;
                          padding: 0;
                        }
                        &:hover {
                          text-decoration: underline;
                        }
                        a {
                          color: $color-primary;
                          font-family: $font-primary-medium;
                        }
                      }
                    }
                  }
                  &--footer {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding-top: 2rem;
                    gap: 1rem;
                    .user-react {
                      width: auto;
                      margin: 0;
                      justify-content: flex-start;
                      &__name {
                        display: none;
                      }
                    }
                    .comments {
                      width: auto;
                      margin-left: auto;
                      button {
                        line-height: normal;
                        font-size: 1.4rem;
                        color: $color-black;
                        border: none;
                        outline: none;
                        display: block;
                        margin-left: auto;
                        background-color: transparent;
                        cursor: pointer;
                        font-family: $font-primary;
                        opacity: 0.7;
                        &:hover {
                          text-decoration: underline;
                        }
                      }
                    }
                  }
                  &:last-child {
                    border-bottom: none;
                  }
                }
                .connection-card-skeleton {
                  margin: 2rem 0 !important;
                }
                &__message {
                  font-size: 1.6rem;
                  font-family: $font-primary;
                  color: $color-black;
                  line-height: 2rem;
                  margin-bottom: 1rem;
                  text-align: center;
                  margin: 2rem 0;
                }
              }
            }
          }
        }
      }
    }
    &::-webkit-scrollbar {
      width: 0.3rem;
      height: 0.3rem;
    }

    &::-webkit-scrollbar-track {
      background-color: transparent;
      border-radius: 0.8rem;
    }

    &::-webkit-scrollbar-thumb {
      background-color: $color-primary;
      border-radius: 0.8rem;
      height: 0.3rem;
    }
  }
}
</style>
